import {useContext, useState} from 'react';
import { CustomerContext } from "./CustomerContext";
import * as CustomerApi from '../../Services/CustomerApi';
import { Link } from 'react-router-dom';
import { Button} from 'react-bootstrap';
import { Box, TextField, Typography, Stack } from '@mui/material';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CustomerSearch({filter, setFilter}) {
    // const [searchBox, setSearchBox] = useState();
    const context = useContext(CustomerContext);

    // useEffect(() => {
    //     if (searchBox) {
    //         ReactDom.findDOMNode(searchBox).focus();
    //     }
    // }, [searchBox]);

    async function clearSearch() {
        setFilter('');
        const custList = await CustomerApi.getUserList();
        context.setCustomerList(custList);
    }

    async function searchKeyHandler(evt) {
        var code = evt.charCode || evt.keyCode;
        if (code === 27) {
            setFilter('');
            const custList = await CustomerApi.getUserList();
            context.setCustomerList(custList);
        }
    }

    async function onSearchTextChange(e){
        setFilter(e.target.value);
    }

    async function handleSearch() {
        const custList = await CustomerApi.getFilteredUserList(filter);
        context.setCustomerList(custList);
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();          
        }
      };

    return (
        <Stack direction="row" style={{padding: '2px 10px 10px 10px'}}>
        {/* <div className="CustomerSearch--wrapper"> */}
        {/* <InputGroup className="mb-3" hasValidation={filter === '' ? 'true' : null }> */}
        {/* <FormControl ref={c => setSearchBox(c)} type="text" className="form-control" id="searchText" placeholder="Search" onChange={onSearchTextChange} value={filter} onKeyUp={searchKeyHandler} /> */}
        <div style={{
            position: 'relative',
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            gap: '10px'
        }}>
            <TextField onKeyDown={handleKeyDown} fullWidth onChange={onSearchTextChange} value={filter} onKeyUp={searchKeyHandler} placeholder="Find customers">
            </TextField>
            <FontAwesomeIcon style={{
                cursor: 'pointer',
                position: 'absolute',
                right: '10px'
            }} onClick={handleSearch} icon={faSearch} title='search'/>
        </div>
        <Button variant="outline" onClick={() => clearSearch()}  hidden={filter === '' ? 'hidden' : null} sx={{ width : 20}} >X</Button>
        {/* </InputGroup> */}
        {/* </div> */}
        </Stack>
            
    )
}

function displayName(customer) {
    const firstName = customer.firstName === null ? '-' : customer.firstName;
    const lastName = customer.lastName === null ? '-' : customer.lastName;
    return firstName  + ' ' + lastName;
}


function CustomerList({customerList, activeCustomerId}) {
        return (
        <div className="CustomerList--wrapper">
            {customerList.map(customer => {
                return (
                    <Link to={'/customer/' + customer.id} key={customer.id} className={ activeCustomerId === customer.id ? 'CustomerList__Item active' : 'CustomerList__Item ' }>
                        <div className="CustomerList__Icon">
                        </div>
                        <div className="CustomerList__Name">
                           <Typography> {displayName(customer)}</Typography>
                        </div>
                        <div className="CustomerList__Email">
                        <Typography>{customer.email}</Typography>
                        </div>

                    </Link>
                )
            })}
        </div>
    )
    
}

function CustomerBrowser({activeCustomerId, setActiveCustomerId, setCustomerList}) {
    const context = useContext(CustomerContext);
    const [filterStr, setFilterStr] = useState('')
    if (context.customerListLoading) {
        return (<div>Customer List Loading...</div>)
    } else {
        return (
        <Box className="ModulePanel ModulePanel--wrapper CustomerBrowser CustomerBrowser--wrapper" sx={{backgroundColor:'white'}}>
        <div className="PanelHeader">Customers</div>
        <CustomerSearch filter={filterStr} setFilter={setFilterStr} setCustomerList={setCustomerList}/>
        <CustomerList customerList={context.customerList} setActiveCustomerId={setActiveCustomerId} activeCustomerId={activeCustomerId}/>
        </Box>
    )}
}

export default CustomerBrowser;